export const schedData = [{
  id: "1",
  name: "ДХИ-2019-Проф-09-12",
  programName: "К-04531  |  Дизайнер хлебобулочных ",
  programType: "Профессиональная",
  formType: "очная",
  orderNumber: "50619-66",
  period: "01.09.2019 - 30.12.2019",
  state: "Действующее",
  competence: "40 | WSI",
  profName: "16472 Пекарь"
}];
